import { render, staticRenderFns } from "./shop-list.vue?vue&type=template&id=a2b087ea&scoped=true&"
import script from "./shop-list.vue?vue&type=script&lang=js&"
export * from "./shop-list.vue?vue&type=script&lang=js&"
import style0 from "./shop-list.vue?vue&type=style&index=0&id=a2b087ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b087ea",
  null
  
)

export default component.exports